export default __webpack_public_path__ + "media/images/logo-cea8a2fc41d6242370ad10680a495684.svg";